import React, { createContext, useContext } from 'react';
import { useInstagramAnalysis } from '@/hooks/useInstagramAnalysis';

interface InstagramAnalysisContextType {
  historicalAnalyses: ReturnType<typeof useInstagramAnalysis>['historicalAnalyses'];
  isLoading: boolean;
  isLoadingHistory: boolean;
  saveAnalysis: ReturnType<typeof useInstagramAnalysis>['saveAnalysis'];
  compareWithPrevious: ReturnType<typeof useInstagramAnalysis>['compareWithPrevious'];
  deleteAnalysis: ReturnType<typeof useInstagramAnalysis>['deleteAnalysis'];
  loadHistoricalAnalyses: ReturnType<typeof useInstagramAnalysis>['loadHistoricalAnalyses'];
}

const InstagramAnalysisContext = createContext<InstagramAnalysisContextType | undefined>(undefined);

export const InstagramAnalysisProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const analysis = useInstagramAnalysis();

  return (
    <InstagramAnalysisContext.Provider value={analysis}>
      {children}
    </InstagramAnalysisContext.Provider>
  );
};

export const useInstagramAnalysisContext = () => {
  const context = useContext(InstagramAnalysisContext);
  if (!context) {
    throw new Error('useInstagramAnalysisContext must be used within an InstagramAnalysisProvider');
  }
  return context;
};
